import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCode, faBriefcase, faBuilding, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import '../styles/Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: 'HolaBichoBola',
      description: 'Son numerosos los servicios que ofrecemos, la pequebola, fiestas de cumpleaños, natación, clases de apoyo, de inglés, música, campamentos de verano...',
      technologies: ['Symfony', 'PHP', 'MySQL', 'Bootstrap', 'JQuery', 'HTML5', 'CSS3', 'JavaScript', 'Responsive Design'],
      image: '/images/imagen_proyecto1.png',
      liveUrl: 'https://www.holabichobola.com',
    },
    {
      id: 2,
      title: 'AizanePhoto',
      description: 'Son numerosos los servicios que ofrecemos, la pequebola, fiestas de cumpleaños, natación, clases de apoyo, de inglés, música, campamentos de verano...',
      technologies: ['Symfony', 'PHP', 'MySQL', 'Bootstrap', 'JQuery', 'HTML5', 'CSS3', 'JavaScript', 'Responsive Design'],
      image: '/images/imagen_proyecto1.png',
      liveUrl: 'https://www.aizanephoto.com',
    },
    {
      id: 3,
      title: 'Portfolio Personal',
      description: 'Este mismo portfolio, desarrollado con React y diseñado para mostrar mis proyectos y habilidades.',
      technologies: ['React', 'CSS3', 'React Router'],
      image: '/images/image_portfolio.png',
      liveUrl: '#',
    },
  ];

  const careerHistory = [
    {
      id: 1,
      company: 'Singular Bank',
      position: 'Full Stack Developer',
      period: 'Octubre 2018 - Actualidad',
      description: 'Desarrollo full-stack para plataforma bancaria digital (API & Front), así como mantenimiento y desarrollo de procesos en C++',
      technologies: ['C++', 'Bash', 'PHP', 'SQL', 'MAYSQL', 'Symfony', 'Docker', 'Linux']
    },
    {
      id: 2,
      company: 'Freelance',
      position: 'Desarrollador Web',
      period: 'Enero 2021 - Actualidad',
      description: 'Desarrollo y mantenimiento de diferentes páginas web, buscando siempre la innovación y utilizando tecnologías modernas.',
      technologies: ['React', 'Node.js', 'Java', 'Spring Boot', 'MongoDB', 'PHP', 'Symfony', 'MySQL', 'SQL', 'HTML5', 'CSS3', 'JavaScript', 'JQuery', 'Angular']
    },
    {
      id: 3,
      company: 'Aprendemás',
      position: 'DESARROLLADOR FULL STACK',
      period: 'Noviembre 2017 - Enero 2018',
      description: 'Desarrollo de API REST, desarrollo de la parte del back-end y front-end de la aplicación web de Aprendemás.',
      technologies: ['PHP', 'Symfony2', 'Angular2', 'SQL', 'elasticsearch']
    },
    {
      id: 4,
      company: 'Grupo 5',
      position: 'Analista Programador',
      period: 'Abril 2017 - Octubre 2017',
      description: 'Colaboración en el desarrollo de una plataforma web. Implementación de funcionalidades front-end y back-end.',
      technologies: ['PHP', 'Symfony', 'MySQL', 'HTML5', 'CSS3', 'JavaScript', 'JQuery', 'Angular']
    }
  ];

  return (
    <div className="projects-container">
      <div className="projects-header">
        <h1 className="projects-title">Trayectoria Profesional</h1>
        <div className="projects-line"></div>
        <p className="projects-subtitle">Mi experiencia laboral en el campo del desarrollo web</p>
      </div>
      
      <div className="career-timeline">
        {careerHistory.map(job => (
          <div key={job.id} className="career-item">
            <div className="career-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="career-content">
              <div className="career-info">
                <h3 className="career-position">{job.position}</h3>
                <div className="career-company">
                  <FontAwesomeIcon icon={faBuilding} />
                  <span>{job.company}</span>
                </div>
                <div className="career-period">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <span>{job.period}</span>
                </div>
              </div>
              <p className="career-description">{job.description}</p>
              <div className="career-tech">
                <div className="tech-tags">
                  {job.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="career-section">
        <div className="career-header">
          <h2 className="career-title">Mis Proyectos</h2>
          <div className="career-line"></div>
          <p className="career-subtitle">Una selección de proyectos que he desarrollado</p>
        </div>
        
        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-links">
                  <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="project-link">
                    <FontAwesomeIcon icon={faGlobe} /> Demo
                  </a>
                </div>
              </div>
              <div className="project-info">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  <FontAwesomeIcon icon={faCode} />
                  <div className="tech-tags">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects; 